import { Monitor, Moon, Sun } from 'lucide-react'
import { useState } from 'react'
import { SegmentedControl } from '../components/SegmentedControl.tsx'
import { SettingsGroup, SettingsRow } from '../components/SettingsGroup.tsx'
import { setThemeChoice, themeChoice, type ThemeChoice } from '../theme.ts'

/** Light, dark or automatic, for this browser. */
export function Appearance() {
  const [choice, setChoice] = useState<ThemeChoice>(themeChoice)
  return (
    <section>
      <div className="section-head">
        <h1>Appearance</h1>
      </div>
      <SettingsGroup>
        <SettingsRow
          title="Theme"
          subtitle="Automatic follows your device's light or dark setting."
          trailing={
            <SegmentedControl
              label="Appearance"
              value={choice}
              onChange={(c) => {
                setChoice(c)
                setThemeChoice(c)
              }}
              options={[
                { value: 'light', label: 'Light', icon: Sun },
                { value: 'dark', label: 'Dark', icon: Moon },
                { value: 'auto', label: 'Automatic', icon: Monitor },
              ]}
            />
          }
        />
      </SettingsGroup>
    </section>
  )
}
